'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoLinksAndDescDisconnected = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _nuiIntl = require('@concur/nui-intl');

var _ReadMore = require('./ReadMore');

var _ReadMore2 = _interopRequireDefault(_ReadMore);

var _ConnectButton = require('./ConnectButton');

var _ConnectButton2 = _interopRequireDefault(_ConnectButton);

var _trackClick = require('../HOCs/trackClick');

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('./style/logoLinks.css') : void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogoLinksAndDesc = function LogoLinksAndDesc(_ref) {
  var listing = _ref.listing,
      toggleDetails = _ref.toggleDetails,
      userPrefs = _ref.userPrefs,
      detailsExpanded = _ref.detailsExpanded,
      listingDisabled = _ref.listingDisabled;
  var _userPrefs$userId = userPrefs.userId,
      userId = _userPrefs$userId === undefined ? '' : _userPrefs$userId;
  var ID = listing.ID,
      _listing$core = listing.core,
      icon = _listing$core.icon,
      listingName = _listing$core.listingName,
      _listing$localized = listing.localized;
  _listing$localized = _listing$localized === undefined ? {} : _listing$localized;
  var partnerListingURL = _listing$localized.partnerListingURL,
      _listing$localized$na = _listing$localized.name,
      name = _listing$localized$na === undefined ? '' : _listing$localized$na,
      _listing$localized$ti = _listing$localized.title,
      title = _listing$localized$ti === undefined ? '' : _listing$localized$ti,
      demonstrationURL = _listing$localized.demonstrationURL,
      brochureURL = _listing$localized.brochureURL,
      contactURL = _listing$localized.contactURL,
      details = _listing$localized.details,
      partnerImage = listing.images.partnerImage;


  var links = {
    partnerListingURL: partnerListingURL,
    demonstrationURL: demonstrationURL,
    brochureURL: brochureURL,
    contactURL: contactURL
  };

  var trackClicked = function trackClicked(element, additional) {
    return _react2.default.createElement(
      _trackClick.Tracked,
      {
        event: 'CLICK',
        additional: _extends(additional, {
          context: 'LISTING_DETAILS',
          type: 'LINK',
          v2_listing_id: ID,
          app_name: listingName,
          domain: window.location.hostname
        })
      },
      element
    );
  };

  var renderLinks = function renderLinks(linksObj) {
    var output = [];
    if (linksObj.partnerListingURL) {
      output.push(trackClicked(_react2.default.createElement(
        'a',
        {
          href: linksObj.partnerListingURL,
          className: 'ac-details-link',
          id: 'ac-partner-listing-url',
          target: '_blank'
        },
        _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'VisitOurWebsite' })
      ), { value: 'PARTNER_LISTING_URL' }));
    }
    if (linksObj.demonstrationURL) {
      output.push(trackClicked(_react2.default.createElement(
        'a',
        {
          href: linksObj.demonstrationURL,
          id: 'ac-demonstration-url',
          className: 'ac-details-link',
          target: '_blank'
        },
        _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'WatchDemo' })
      ), { value: 'DEMONSTRATION_URL' }));
    }
    if (linksObj.brochureURL) {
      output.push(trackClicked(_react2.default.createElement(
        'a',
        {
          href: linksObj.brochureURL,
          className: 'ac-details-link',
          target: '_blank',
          id: 'ac-brochure-url'
        },
        _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Brochure' })
      ), { value: 'BROCHURE_URL' }));
    }
    if (linksObj.contactURL) {
      output.push(trackClicked(_react2.default.createElement(
        'a',
        {
          href: linksObj.contactURL,
          id: 'ac-contact-url',
          className: 'ac-details-link',
          target: '_blank'
        },
        _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Support' })
      ), { value: 'CONTACT_URL' }));
    }
    return output.map(function (el, i, arr) {
      return _react2.default.createElement(
        'span',
        { key: i + 'links' },
        el,
        i < arr.length - 1 && ' | '
      );
    });
  };

  var renderReadMore = function renderReadMore() {
    return trackClicked(_react2.default.createElement(_ReadMore2.default, {
      text: details,
      isExpanded: detailsExpanded,
      expand: toggleDetails
    }), { value: 'READ_MORE' });
  };

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col-sm-9 col-xs-12' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-2 col-xs-3 imgDiv' },
            _react2.default.createElement('img', {
              alt: 'Partner Image',
              className: 'icon-image',
              src: icon || partnerImage || 'https://www.concursolutions.com/static/images/brand/logo-SAPConcur-20171204.svg'
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-sm-6 col-xs-6 partner-name-and-title' },
            _react2.default.createElement(
              'h1',
              { className: 'ac-listing-name' },
              name
            ),
            _react2.default.createElement(
              'p',
              { className: 'ac-listing-title' },
              title
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-10 read-more-area' },
            renderReadMore(),
            renderLinks(links, ID, listingName)
          )
        )
      ),
      _react2.default.createElement('div', { className: 'clearfix visible-xs' }),
      _react2.default.createElement(
        'div',
        { className: 'col-sm-3 col-xs-3' },
        _react2.default.createElement(_ConnectButton2.default, {
          listing: listing,
          isDisabled: listingDisabled,
          userPrefs: userPrefs
        })
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userPrefs: state.userPrefs
  };
};

LogoLinksAndDesc.propTypes = {
  listing: _propTypes2.default.shape({
    ID: _propTypes2.default.string,
    core: _propTypes2.default.object,
    images: _propTypes2.default.object,
    localized: _propTypes2.default.object,
    loyaltyNumber: _propTypes2.default.string,
    v1data: _propTypes2.default.object
  }).isRequired,
  toggleDetails: _propTypes2.default.func.isRequired,
  userPrefs: _propTypes2.default.shape({
    userId: _propTypes2.default.string
  }),
  detailsExpanded: _propTypes2.default.bool.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(LogoLinksAndDesc);
exports.LogoLinksAndDescDisconnected = LogoLinksAndDesc;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/LogoLinksAndDesc.js
// module id = 580
// module chunks = 0